// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriptionV2ProgramNdcGetByProgramIdProgramIdGetByProgramIdResponse {
    static getAttributeTypeMap() {
        return PrescriptionV2ProgramNdcGetByProgramIdProgramIdGetByProgramIdResponse.attributeTypeMap;
    }
}
PrescriptionV2ProgramNdcGetByProgramIdProgramIdGetByProgramIdResponse.discriminator = undefined;
PrescriptionV2ProgramNdcGetByProgramIdProgramIdGetByProgramIdResponse.additionalProperties = false;
PrescriptionV2ProgramNdcGetByProgramIdProgramIdGetByProgramIdResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=prescriptionV2ProgramNdcGetByProgramIdProgramIdGetByProgramIdResponse.js.map